module.exports = "/assets/_next/static/images/incomplete-newsletter-2e0f23e45fdf56f5e935600e18c94664.png";